export default "__VITE_ASSET__24f82129__"